import React from 'react';
import ServicesHero from '../components/ServicesHero';
import ServicesFeatures from '../components/ServicesFeatures';
import ServicesCoreLogistics from '../components/ServicesCoreLogistics';
import ServicesIndustries from '../components/ServicesIndustries';
import ServicesVideo from '../components/ServicesVideo';
import ServicesHowWeWork from '../components/ServicesHowWeWork';

const ServicesPage = () => {
    return (
        <div>
            <ServicesHero />
            <ServicesFeatures />
            <ServicesCoreLogistics />
            <ServicesIndustries />
            <ServicesVideo />
            <ServicesHowWeWork />
        </div>
    );
};

export default ServicesPage;
